export class DataComponent {
  titleCategory:string = "";
  dataTemp=[];
  totalPageDashboard;

  votersArray = {
    "1": {
      "total_voter": 3155
    },
    "2": {
      "total_voter": 2414
    },
    "3": {
      "total_voter": 2266
    },
    "4": {
      "total_voter": 3022
    },
    "5": {
      "total_voter": 2991
    },
    "6": {
      "total_voter": 1822
    },
    "7": {
      "total_voter": 2412
    },
    "8": {
      "total_voter": 3149
    },
    "9": {
      "total_voter": 2274
    },
    "10": {
      "total_voter": 2537
    },
    "11": {
      "total_voter": 2888
    },
    "12": {
      "total_voter": 2410
    },
    "13": {
      "total_voter": 3234
    },
    "14": {
      "total_voter": 2051
    },
    "15": {
      "total_voter": 2550
    },
    "16": {
      "total_voter": 1855
    },
    "17": {
      "total_voter": 3034
    },
    "18": {
      "total_voter": 2946
    },
    "19": {
      "total_voter": 2524
    },
    "20": {
      "total_voter": 1856
    },
    "21": {
      "total_voter": 3455
    },
    "22": {
      "total_voter": 3130
    },
    "23": {
      "total_voter": 2776
    },
    "24": {
      "total_voter": 1929
    },
    "25": {
      "total_voter": 2285
    },
    "26": {
      "total_voter": 2876
    },
    "27": {
      "total_voter": 2674
    },
    "28": {
      "total_voter": 2408
    },
    "29": {
      "total_voter": 3189
    },
    "30": {
      "total_voter": 2238
    },
    "31": {
      "total_voter": 2228
    },
    "32": {
      "total_voter": 3189
    },
    "33": {
      "total_voter": 2418
    },
    "34": {
      "total_voter": 3425
    },
    "35": {
      "total_voter": 2180
    },
    "36": {
      "total_voter": 2230
    },
    "37": {
      "total_voter": 2264
    },
    "38": {
      "total_voter": 3226
    },
    "39": {
      "total_voter": 2345
    },
    "40": {
      "total_voter": 2427
    },
    "41": {
      "total_voter": 2256
    },
    "42": {
      "total_voter": 3152
    },
    "43": {
      "total_voter": 1962
    },
    "44": {
      "total_voter": 3351
    },
    "45": {
      "total_voter": 2522
    },
    "46": {
      "total_voter": 3069
    },
    "47": {
      "total_voter": 2297
    },
    "48": {
      "total_voter": 2469
    },
    "49": {
      "total_voter": 3065
    },
    "50": {
      "total_voter": 2524
    },
    "51": {
      "total_voter": 2246
    },
    "52": {
      "total_voter": 3132
    },
    "53": {
      "total_voter": 2502
    },
    "54": {
      "total_voter": 2201
    },
    "55": {
      "total_voter": 2193
    },
    "56": {
      "total_voter": 3116
    },
    "57": {
      "total_voter": 2526
    },
    "58": {
      "total_voter": 2495
    },
    "59": {
      "total_voter": 2308
    },
    "60": {
      "total_voter": 3032
    },
    "61": {
      "total_voter": 3094
    },
    "62": {
      "total_voter": 2191
    },
    "63": {
      "total_voter": 2550
    },
    "64": {
      "total_voter": 3584
    },
    "65": {
      "total_voter": 2102
    },
    "66": {
      "total_voter": 2149
    },
    "67": {
      "total_voter": 2393
    },
    "68": {
      "total_voter": 2317
    },
    "69": {
      "total_voter": 3125
    },
    "70": {
      "total_voter": 2274
    },
    "71": {
      "total_voter": 3041
    },
    "72": {
      "total_voter": 2520
    },
    "73": {
      "total_voter": 3230
    },
    "74": {
      "total_voter": 2189
    },
    "75": {
      "total_voter": 2416
    },
    "76": {
      "total_voter": 3344
    },
    "77": {
      "total_voter": 2233
    },
    "78": {
      "total_voter": 2258
    },
    "79": {
      "total_voter": 2230
    },
    "80": {
      "total_voter": 2345
    },
    "81": {
      "total_voter": 3260
    },
    "82": {
      "total_voter": 2517
    },
    "83": {
      "total_voter": 2113
    },
    "84": {
      "total_voter": 3205
    },
    "85": {
      "total_voter": 2991
    },
    "86": {
      "total_voter": 2438
    },
    "87": {
      "total_voter": 2406
    },
    "88": {
      "total_voter": 3506
    },
    "89": {
      "total_voter": 2159
    },
    "90": {
      "total_voter": 2170
    },
    "91": {
      "total_voter": 3193
    },
    "92": {
      "total_voter": 2207
    },
    "93": {
      "total_voter": 2435
    },
    "94": {
      "total_voter": 2232
    },
    "95": {
      "total_voter": 2530
    },
    "96": {
      "total_voter": 3073
    },
    "97": {
      "total_voter": 3411
    },
    "98": {
      "total_voter": 2157
    },
    "99": {
      "total_voter": 2267
    },
    "100": {
      "total_voter": 2102
    },
    "101": {
      "total_voter": 2100
    },
    "102": {
      "total_voter": 3633
    },
    "103": {
      "total_voter": 3016
    },
    "104": {
      "total_voter": 2165
    },
    "105": {
      "total_voter": 2654
    },
    "106": {
      "total_voter": 2501
    },
    "107": {
      "total_voter": 2176
    },
    "108": {
      "total_voter": 3158
    }
  }

  nomineeArray = 
    [
      {
        "_id": "5b9f666796f1ec36cc23b22d",
        "category_name": "Best Luxury Hotel",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/THE ST. REGIS BALI RESORT.jpg",
              "name": "THE ST. REGIS BALI RESORT",
              "id": 4
            },
            {
              "status": false,
              "image": "./assets/img/list/SOFITEL BALI NUSA DUA BEACH RESORT.jpg",
              "name": "SOFITEL BALI NUSA DUA BEACH RESORT",
              "id": 5
            },
            {
              "status": false,
              "image": "./assets/img/list/MANDAPA, A RITZ-CARLTON RESERVE.jpg",
              "name": "MANDAPA, A RITZ-CARLTON RESERVE",
              "id": 6
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/RAFFLES JAKARTA HOTEL.jpg",
              "name": "RAFFLES JAKARTA",
              "id": 1
            },
            {
              "status": false,
              "image": "./assets/img/list/FOUR SEASONS HOTEL JAKARTA.jpg",
              "name": "FOUR SEASONS HOTEL JAKARTA",
              "id": 2
            },
            {
              "status": false,
              "image": "./assets/img/list/HOTEL MULIA SENAYAN HOTEL.jpg",
              "name": "HOTEL MULIA SENAYAN, JAKARTA",
              "id": 3
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b22e",
        "category_name": "Best Business Hotel",
        "location": {
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/SHANGRI-LA HOTEL, JAKARTA.jpg",
              "name": "SHANGRI-LA HOTEL, JAKARTA",
              "id": 7
            },
            {
              "status": false,
              "image": "./assets/img/list/THE WESTIN JAKARTA.jpg",
              "name": "THE WESTIN JAKARTA",
              "id": 8
            },
            {
              "status": false,
              "image": "./assets/img/list/THE RITZ-CARLTON JAKARTA, MEGA KUNINGAN.jpg",
              "name": "THE RITZ-CARLTON JAKARTA, MEGA KUNINGAN",
              "id": 9
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b22f",
        "category_name": "Best Hotel Villas",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/ALILA VILLAS ULUWATU HOTEL.jpg",
              "name": "ALILA VILLAS ULUWATU",
              "id": 10
            },
            {
              "status": false,
              "image": "./assets/img/list/THE MULIA, MULIA RESORT & VILLAS - NUSA DUA, BALI.jpg",
              "name": "MULIA VILLAS",
              "id": 11
            },
            {
              "status": false,
              "image": "./assets/img/list/THE SAMAYA SEMINYAK BALI.jpg",
              "name": "THE SAMAYA SEMINYAK, BALI",
              "id": 12
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b230",
        "category_name": "Best Family Hotel",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/THE ANVAYA BEACH RESORT BALI.jpg",
              "name": "THE ANVAYA BEACH RESORT BALI",
              "id": 16
            },
            {
              "status": false,
              "image": "./assets/img/list/THE WESTIN RESORT NUSA DUA, BALI.jpg",
              "name": "THE WESTIN RESORT NUSA DUA, BALI",
              "id": 17
            },
            {
              "status": false,
              "image": "./assets/img/list/MASON ELEPHANT LODGE.jpg",
              "name": "MASON ELEPHANT LODGE",
              "id": 18
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/SHANGRI-LA HOTEL, JAKARTA.jpg",
              "name": "SHANGRI-LA HOTEL, JAKARTA",
              "id": 13
            },
            {
              "status": false,
              "image": "./assets/img/list/RITZ-CARLTON PACIFIC PLACE.jpg",
              "name": "RITZ-CARLTON PACIFIC PLACE",
              "id": 14
            },
            {
              "status": false,
              "image": "./assets/img/list/HOTEL BOROBUDUR JAKARTA.jpg",
              "name": "HOTEL BOROBUDUR JAKARTA",
              "id": 15
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b231",
        "category_name": "Best Suites",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/W BALI - SEMINYAK.jpg",
              "name": "W BALI - SEMINYAK",
              "id": 22
            },
            {
              "status": false,
              "image": "./assets/img/list/DOUBLE-SIX LUXURY HOTEL.jpg",
              "name": "DOUBLE-SIX LUXURY HOTEL - SEMINYAK",
              "id": 23
            },
            {
              "status": false,
              "image": "./assets/img/list/ALILA SEMINYAK.jpg",
              "name": "ALILA SEMINYAK",
              "id": 24
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/HOTEL FAIRMONT JAKARTA.jpg",
              "name": "HOTEL FAIRMONT JAKARTA",
              "id": 19
            },
            {
              "status": false,
              "image": "./assets/img/list/GRAND HYATT JAKARTA.jpg",
              "name": "GRAND HYATT JAKARTA",
              "id": 20
            },
            {
              "status": false,
              "image": "./assets/img/list/HOTEL INDONESIA KEMPINSKI JAKARTA HOTEL.jpg",
              "name": "HOTEL INDONESIA KEMPINSKI JAKARTA",
              "id": 21
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b232",
        "category_name": "Best Wedding Venue",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/ALILA VILLAS ULUWATU WEDDING.jpg",
              "name": "ALILA VILLAS ULUWATU",
              "id": 28
            },
            {
              "status": false,
              "image": "./assets/img/list/AYANA RESORT & SPA BALI.jpg",
              "name": "AYANA RESORT & SPA BALI",
              "id": 29
            },
            {
              "status": false,
              "image": "./assets/img/list/THE EDGE.jpg",
              "name": "THE EDGE",
              "id": 30
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/HOTEL INDONESIA KEMPINSKI JAKARTA WEDDING.jpg",
              "name": "HOTEL INDONESIA KEMPINSKI JAKARTA",
              "id": 25
            },
            {
              "status": false,
              "image": "./assets/img/list/HOTEL MULIA SENAYAN WEDDING.jpg",
              "name": "HOTEL MULIA SENAYAN",
              "id": 26
            },
            {
              "status": false,
              "image": "./assets/img/list/PULLMAN JAKARTA INDONESIA.jpg",
              "name": "PULLMAN JAKARTA INDONESIA",
              "id": 27
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b233",
        "category_name": "Best Spa",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/SPA AT AYANA.jpg",
              "name": "THERMES MARINS BALI",
              "id": 34
            },
            {
              "status": false,
              "image": "./assets/img/list/SPA AT MAYA UBUD.jpg",
              "name": "SPA AT MAYA UBUD",
              "id": 35
            },
            {
              "status": false,
              "image": "./assets/img/list/THE SPA AT THE LEGIAN BALI.jpg",
              "name": "THE SPA AT THE LEGIAN BALI",
              "id": 36
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/MANDARIN ORIENTAL JAKARTA.jpg",
              "name": "FITNESS & WELLNESS AT MANDARIN ORIENTAL, JAKARTA",
              "id": 31
            },
            {
              "status": false,
              "image": "./assets/img/list/RAFFLES JAKARTA SPA.jpg",
              "name": "RAFFLES JAKARTA",
              "id": 32
            },
            {
              "status": false,
              "image": "./assets/img/list/KERATON AT THE PLAZA.jpg",
              "name": "KERATON AT THE PLAZA",
              "id": 33
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b234",
        "category_name": "Best New Hotel",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/CAPELLA UBUD, BALI.jpg",
              "name": "RADISSON BLU BALI ULUWATU",
              "id": 40
            },
            {
              "status": false,
              "image": "./assets/img/list/RENAISSANCE BALI ULUWATU RESORT & SPA.jpg",
              "name": "RENAISSANCE BALI ULUWATU RESORT & SPA",
              "id": 41
            },
            {
              "status": false,
              "image": "./assets/img/list/SIX SENSES ULUWATU, BALI.jpg",
              "name": "SIX SENSES ULUWATU, BALI",
              "id": 42
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/HOTEL INTERCONTINENTAL JAKARTA.jpg",
              "name": "HOTEL INTERCONTINENTAL JAKARTA",
              "id": 37
            },
            {
              "status": false,
              "image": "./assets/img/list/MERCURE JAKARTA PANTAI INDAH KAPUK.jpg",
              "name": "MERCURE JAKARTA PANTAI INDAH KAPUK",
              "id": 38
            },
            {
              "status": false,
              "image": "./assets/img/list/PARK HYATT.jpg",
              "name": "PARK HYATT",
              "id": 39
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b235",
        "category_name": "Best Fine Dining",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/KAYUPUTI AT THE ST. REGIS BALI RESORT DINING.jpg",
              "name": "KAYUPUTI AT THE ST. REGIS BALI RESORT",
              "id": 46
            },
            {
              "status": false,
              "image": "./assets/img/list/MOZAIC.jpg",
              "name": "MOZAIC",
              "id": 47
            },
            {
              "status": false,
              "image": "./assets/img/list/KUBU AT MANDAPA, A RITZ-CARLTON RESERVE.jpg",
              "name": "KUBU AT MANDAPA, A RITZ-CARLTON RESERVE",
              "id": 48
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/AMUZ.jpg",
              "name": "AMUZ",
              "id": 43
            },
            {
              "status": false,
              "image": "./assets/img/list/AKIRA BACK.jpg",
              "name": "AKIRA BACK",
              "id": 44
            },
            {
              "status": false,
              "image": "./assets/img/list/VONG KITCHEN.jpg",
              "name": "VONG KITCHEN",
              "id": 45
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b236",
        "category_name": "Best Casual Dining",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/SEASALT AT ALILA SEMINYAK.jpg",
              "name": "SEASALT AT ALILA SEMINYAK",
              "id": 52
            },
            {
              "status": false,
              "image": "./assets/img/list/MAKASE AT HOTEL INDIGO BALI SEMINYAK BEACH.jpg",
              "name": "MAKASE AT HOTEL INDIGO BALI SEMINYAK BEACH",
              "id": 53
            },
            {
              "status": false,
              "image": "./assets/img/list/CUCA.jpg",
              "name": "CUCA",
              "id": 54
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/BAE BY SOCIEATY.jpg",
              "name": "BAE BY SOCIEATY",
              "id": 49
            },
            {
              "status": false,
              "image": "./assets/img/list/COLLAGE ALL DAY DINING AT PULLMAN JAKARTA CENTRAL PARK .jpg",
              "name": "COLLAGE ALL DAY DINING AT PULLMAN JAKARTA CENTRAL PARK ",
              "id": 50
            },
            {
              "status": false,
              "image": "./assets/img/list/UP IN SMOKE.jpg",
              "name": "UP IN SMOKE",
              "id": 51
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b237",
        "category_name": "Best Brunch",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/SOLEIL AT THE MULIA, MULIA RESORT & VILLAS - NUSA DUA BALI.jpg",
              "name": "SOLEIL AT THE MULIA, MULIA RESORT & VILLAS - NUSA DUA BALI",
              "id": 58
            },
            {
              "status": false,
              "image": "./assets/img/list/KAYUPUTI AT THE ST. REGIS BALI RESORT BRUNCH.jpg",
              "name": "KAYUPUTI AT THE ST. REGIS BALI RESORT",
              "id": 59
            },
            {
              "status": false,
              "image": "./assets/img/list/CUCINA AT SOFITEL BALI NUSA DUA BEACH RESORT BRUNCH.jpg",
              "name": "CUCINA AT SOFITEL BALI NUSA DUA BEACH RESORT",
              "id": 60
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/ASIA AT THE RITZ-CARLTON JAKARTA, MEGA KUNINGAN.jpg",
              "name": "ASIA AT THE RITZ-CARLTON JAKARTA, MEGA KUNINGAN",
              "id": 55
            },
            {
              "status": false,
              "image": "./assets/img/list/SEASONAL TASTES AT THE WESTIN JAKARTA.jpg",
              "name": "SEASONAL TASTES AT THE WESTIN JAKARTA",
              "id": 56
            },
            {
              "status": false,
              "image": "./assets/img/list/BENGAWAN RESTAURANT AT KERATON AT THE PLAZA.jpg",
              "name": "BENGAWAN RESTAURANT AT KERATON AT THE PLAZA",
              "id": 57
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b238",
        "category_name": "Best Steakhouse",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/PLANTATION GRILL AT DOUBLE SIX LUXURY HOTEL.jpg",
              "name": "PLANTATION GRILL AT DOUBLE SIX LUXURY HOTEL",
              "id": 64
            },
            {
              "status": false,
              "image": "./assets/img/list/SALAZON.jpg",
              "name": "SALAZON",
              "id": 65
            },
            {
              "status": false,
              "image": "./assets/img/list/FIRE AT W BALI - SEMINYAK.jpg",
              "name": "FIRE AT W BALI - SEMINYAK",
              "id": 66
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/RUTH'S CHRIS STEAK HOUSE.jpg",
              "name": "RUTH'S CHRIS STEAK HOUSE",
              "id": 61
            },
            {
              "status": false,
              "image": "./assets/img/list/AB STEAK.jpg",
              "name": "AB STEAK",
              "id": 62
            },
            {
              "status": false,
              "image": "./assets/img/list/C'S STEAK AND SEAFOOD AT GRAND HYATT JAKARTA.jpg",
              "name": "C'S STEAK AND SEAFOOD AT GRAND HYATT JAKARTA",
              "id": 63
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b239",
        "category_name": "Best Chinese Restaurant",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/AH YAT ABALONE SEAFOOD RESTAURANT.jpg",
              "name": "AH YAT ABALONE SEAFOOD RESTAURANT",
              "id": 70
            },
            {
              "status": false,
              "image": "./assets/img/list/TABLE8 AT THE MULIA, MULIA RESORT & VILLAS - NUSA DUA BALI.jpg",
              "name": "TABLE8 AT THE MULIA, MULIA RESORT & VILLAS - NUSA DUA BALI",
              "id": 71
            },
            {
              "status": false,
              "image": "./assets/img/list/HAPPY CHAPPY.jpg",
              "name": "HAPPY CHAPPY",
              "id": 72
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/PEARL CHINESE RESTAURANT AT JW MARRIOTT HOTEL JAKARTA.jpg",
              "name": "PEARL CHINESE RESTAURANT AT JW MARRIOTT HOTEL JAKARTA",
              "id": 67
            },
            {
              "status": false,
              "image": "./assets/img/list/TIEN CHAO AT GRAN MELIA JAKARTA.jpg",
              "name": "TIEN CHAO AT GRAN MELIA JAKARTA",
              "id": 68
            },
            {
              "status": false,
              "image": "./assets/img/list/LI FENG AT MANDARIN ORIENTAL, JAKARTA.jpg",
              "name": "LI FENG AT MANDARIN ORIENTAL, JAKARTA",
              "id": 69
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b23a",
        "category_name": "Best Japanese Restaurant",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/SAKE NO HANA.jpg",
              "name": "SAKE NO HANA",
              "id": 76
            },
            {
              "status": false,
              "image": "./assets/img/list/TENKAI AT PADMA RESORT LEGIAN.jpg",
              "name": "TENKAI AT PADMA RESORT LEGIAN",
              "id": 77
            },
            {
              "status": false,
              "image": "./assets/img/list/NAMPU AT GRAND HYATT BALI.jpg",
              "name": "NAMPU AT GRAND HYATT BALI",
              "id": 78
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/OKU AT HOTEL INDONESIA KEMPINSKI JAKARTA.jpg",
              "name": "OKU AT HOTEL INDONESIA KEMPINSKI JAKARTA",
              "id": 73
            },
            {
              "status": false,
              "image": "./assets/img/list/MOMOZEN.jpg",
              "name": "MOMOZEN",
              "id": 74
            },
            {
              "status": false,
              "image": "./assets/img/list/ASUKA AT JW MARRIOTT HOTEL JAKARTA.jpg",
              "name": "ASUKA AT JW MARRIOTT HOTEL JAKARTA",
              "id": 75
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b23b",
        "category_name": "Best Indonesian Restaurant",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/MERAH PUTIH.jpg",
              "name": "MERAH PUTIH",
              "id": 82
            },
            {
              "status": false,
              "image": "./assets/img/list/BLANCO PAR MANDIF.jpg",
              "name": "BLANCO PAR MANDIF",
              "id": 83
            },
            {
              "status": false,
              "image": "./assets/img/list/KAUM AT POTATO HEAD BALI.jpg",
              "name": "KAUM AT POTATO HEAD BALI",
              "id": 84
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/BOGOR CAFE AT HOTEL BOROBUDUR JAKARTA.jpg",
              "name": "BOGOR CAFE AT HOTEL BOROBUDUR JAKARTA",
              "id": 79
            },
            {
              "status": false,
              "image": "./assets/img/list/JAKARTA AT THE DHARMAWANGSA JAKARTA.jpg",
              "name": "JAKARTA AT THE DHARMAWANGSA JAKARTA",
              "id": 80
            },
            {
              "status": false,
              "image": "./assets/img/list/PLATARAN MENTENG.jpg",
              "name": "PLATARAN MENTENG",
              "id": 81
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b23c",
        "category_name": "Best Mediterranean Restaurant",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/CUCINA AT SOFITEL BALI NUSA DUA BEACH RESORT RESTAURANT.jpg",
              "name": "CUCINA AT SOFITEL BALI NUSA DUA BEACH RESORT",
              "id": 88
            },
            {
              "status": false,
              "image": "./assets/img/list/SETTIMO CIELO.jpg",
              "name": "SETTIMO CIELO",
              "id": 89
            },
            {
              "status": false,
              "image": "./assets/img/list/IL RISTORANTE - LUKA FANTIN AT BVLGARI RESORT BALI.jpg",
              "name": "IL RISTORANTE - LUCA FANTIN AT BVLGARI RESORT BALI",
              "id": 90
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/ROSSO AT SHANGRI-LA HOTEL, JAKARTA.jpg",
              "name": "ROSSO AT SHANGRI-LA HOTEL, JAKARTA",
              "id": 85
            },
            {
              "status": false,
              "image": "./assets/img/list/BISTRO GARCON.jpg",
              "name": "GARCON",
              "id": 86
            },
            {
              "status": false,
              "image": "./assets/img/list/ALTO AT FOUR SEASONS HOTEL JAKARTA.jpg",
              "name": "ALTO AT FOUR SEASONS HOTEL JAKARTA",
              "id": 87
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b23d",
        "category_name": "Best After Dinner Nightlife",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/40 THIEVES.jpg",
              "name": "40 THIEVES",
              "id": 94
            },
            {
              "status": false,
              "image": "./assets/img/list/EN VIE LOUNGE.jpg",
              "name": "EN VIE LOUNGE",
              "id": 95
            },
            {
              "status": false,
              "image": "./assets/img/list/WOOBAR AT W BALI - SEMINYAK.jpg",
              "name": "WOOBAR AT W BALI - SEMINYAK",
              "id": 96
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/DRAGONFLY.jpg",
              "name": "DRAGONFLY",
              "id": 91
            },
            {
              "status": false,
              "image": "./assets/img/list/K22 BAR.jpg",
              "name": "K22 BAR",
              "id": 92
            },
            {
              "status": false,
              "image": "./assets/img/list/IMMIGRANT.jpg",
              "name": "IMMIGRANT",
              "id": 93
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b23e",
        "category_name": "Best Bar",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/FRESTRO & BAR.jpg",
              "name": "FRESTRO & BAR",
              "id": 100
            },
            {
              "status": false,
              "image": "./assets/img/list/TREE BAR AT HOTEL INDIGO BALI SEMINYAK BEACH.jpg",
              "name": "TREE BAR AT HOTEL INDIGO BALI SEMINYAK BEACH",
              "id": 101
            },
            {
              "status": false,
              "image": "./assets/img/list/SLING BAR AT DOUBLE-SIX LUXURY HOTEL.jpg",
              "name": "SLING BAR AT DOUBLE-SIX LUXURY HOTEL",
              "id": 102
            }
          ],
          "jakarta": [
            {
              "status": false,
              "image": "./assets/img/list/HENSHIN AT THE WESTIN JAKARTA.jpg",
              "name": "HENSHIN AT THE WESTIN JAKARTA",
              "id": 97
            },
            {
              "status": false,
              "image": "./assets/img/list/HAVANA.jpg",
              "name": "HAVANA",
              "id": 98
            },
            {
              "status": false,
              "image": "./assets/img/list/WRITER'S BAR AT RAFFLES JAKARTA.jpg",
              "name": "WRITER'S BAR AT RAFFLES JAKARTA",
              "id": 99
            }
          ]
        }
      },
      {
        "_id": "5b9f666796f1ec36cc23b23f",
        "category_name": "Best Beach Club",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/OMNIA.jpg",
              "name": "OMNIA",
              "id": 103
            },
            {
              "status": false,
              "image": "./assets/img/list/EL KABRON SPANISH RESTAURANT & CLIFF CLUB.jpg",
              "name": "EL KABRON",
              "id": 104
            },
            {
              "status": false,
              "image": "./assets/img/list/POTATO HEAD BALI.jpg",
              "name": "POTATO HEAD BALI",
              "id": 105
            }
          ]
        }
      },
      {
        "_id": "5ba4a4875a155828f4d343b9",
        "category_name": "New Beach Club",
        "location": {
          "bali": [
            {
              "status": false,
              "image": "./assets/img/list/MANARAI BEACH HOUSE.jpg",
              "name": "MANARAI BEACH HOUSE",
              "id": 106
            },
            {
              "status": false,
              "image": "./assets/img/list/SUGARSAND.jpg",
              "name": "SUGARSAND",
              "id": 107
            },
            {
              "status": false,
              "image": "./assets/img/list/ROOSTERFISH BEACH CLUB.jpg",
              "name": "ROOSTERFISH BEACH CLUB",
              "id": 108
            }
          ]
        }
      }
    ]

  readerArray = [{
          "_id": "5ba920fc5a15581eccdd0bf5",
          "id": 109,
          "name": "ALAYA RESORT UBUD",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 90
        }, {
          "_id": "5ba920fc5a15581eccdd0bf6",
          "id": 110,
          "name": "ALILA SEMINYAK",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 65
        }, {
          "_id": "5ba920fc5a15581eccdd0bf7",
          "id": 111,
          "name": "ALILA VILLAS ULUWATU",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 65
        }, {
          "_id": "5ba920fc5a15581eccdd0bf8",
          "id": 112,
          "name": "ANANTARA SEMINYAK BALI RESORT",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 65
        }, {
          "_id": "5ba920fc5a15581eccdd0bf9",
          "id": 113,
          "name": "ANANTARA ULUWATU BALI RESORT",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 48
        }, {
          "_id": "5ba920fc5a15581eccdd0bfa",
          "id": 114,
          "name": "AYANA RESORT & SPA BALI",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 55
        }, {
          "_id": "5ba920fc5a15581eccdd0bfb",
          "id": 115,
          "name": "AYODYA RESORT BALI",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 52
        }, {
          "_id": "5ba920fc5a15581eccdd0bfc",
          "id": 116,
          "name": "BALI NIKSOMA BOUTIQUE BEACH RESORT",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 55
        }, {
          "_id": "5ba920fc5a15581eccdd0bfd",
          "id": 117,
          "name": "BISMA EIGHT",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 47
        }, {
          "_id": "5ba920fc5a15581eccdd0bfe",
          "id": 118,
          "name": "BVLGARI RESORT BALI",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 39
        }, {
          "_id": "5ba920fc5a15581eccdd0bff",
          "id": 119,
          "name": "CAPELLA UBUD, BALI",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 35
        }, {
          "_id": "5ba920fc5a15581eccdd0c00",
          "id": 120,
          "name": "COURTYARD BY MARRIOTT BALI SEMINYAK RESORT",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 36
        }, {
          "_id": "5ba920fc5a15581eccdd0c01",
          "id": 121,
          "name": "DESA VISESA UBUD",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 36
        }, {
          "_id": "5ba920fc5a15581eccdd0c02",
          "id": 122,
          "name": "DOUBLE-SIX LUXURY HOTEL, SEMINYAK",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 1647
        }, {
          "_id": "5ba920fc5a15581eccdd0c03",
          "id": 123,
          "name": "FAIRMONT SANUR BEACH BALI",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 52
        }, {
          "_id": "5ba920fc5a15581eccdd0c04",
          "id": 124,
          "name": "FOUR POINTS BY SHERATON BALI, KUTA",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 26
        }, {
          "_id": "5ba920fc5a15581eccdd0c05",
          "id": 125,
          "name": "FOUR POINTS BY SHERATON BALI, SEMINYAK",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 22
        }, {
          "_id": "5ba920fc5a15581eccdd0c06",
          "id": 126,
          "name": "HARD ROCK HOTEL BALI",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 28
        }, {
          "_id": "5ba920fc5a15581eccdd0c07",
          "id": 127,
          "name": "HILTON GARDEN INN BALI NGURAH RAI AIRPORT",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 18
        }, {
          "_id": "5ba920fc5a15581eccdd0c08",
          "id": 128,
          "name": "HOTEL INDIGO BALI SEMINYAK BEACH",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 19
        }, {
          "_id": "5ba920fc5a15581eccdd0c09",
          "id": 129,
          "name": "HOTEL NIKKO BALI - BENOA BEACH",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 12
        }, {
          "_id": "5ba920fc5a15581eccdd0c0a",
          "id": 130,
          "name": "KAMANDALU UBUD",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 14
        }, {
          "_id": "5ba920fc5a15581eccdd0c0b",
          "id": 131,
          "name": "LE MERIDIEN BALI JIMBARAN",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 11
        }, {
          "_id": "5ba920fc5a15581eccdd0c0c",
          "id": 132,
          "name": "MANDAPA, A RITZ-CARLTON RESERVE",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 1278
        }, {
          "_id": "5ba920fc5a15581eccdd0c0d",
          "id": 133,
          "name": "MASON ELEPHANT LODGE",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 7
        }, {
          "_id": "5ba920fc5a15581eccdd0c0e",
          "id": 134,
          "name": "MAYA SANUR RESORT & SPA",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 11
        }, {
          "_id": "5ba920fc5a15581eccdd0c0f",
          "id": 135,
          "name": "MAYA UBUD RESORT & SPA",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 10
        }, {
          "_id": "5ba920fc5a15581eccdd0c10",
          "id": 136,
          "name": "MÖVENPICK RESORT & SPA JIMBARAN BALI",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 13
        }, {
          "_id": "5ba920fc5a15581eccdd0c11",
          "id": 137,
          "name": "NUSA DUA BEACH HOTEL & SPA",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 9
        }, {
          "_id": "5ba920fc5a15581eccdd0c12",
          "id": 138,
          "name": "PADMA RESORT LEGIAN",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 101
        }, {
          "_id": "5ba920fc5a15581eccdd0c13",
          "id": 139,
          "name": "PADMA RESORT UBUD",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 18
        }, {
          "_id": "5ba920fc5a15581eccdd0c14",
          "id": 140,
          "name": "RADISSON BLU BALI ULUWATU",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 8
        }, {
          "_id": "5ba920fc5a15581eccdd0c15",
          "id": 141,
          "name": "RENAISSANCE BALI ULUWATU RESORT & SPA",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 7
        }, {
          "_id": "5ba920fc5a15581eccdd0c16",
          "id": 142,
          "name": "RIMBA JIMBARAN BALI BY AYANA",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 8
        }, {
          "_id": "5ba920fc5a15581eccdd0c17",
          "id": 143,
          "name": "SIX SENSES ULUWATU, BALI",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 7
        }, {
          "_id": "5ba920fc5a15581eccdd0c18",
          "id": 144,
          "name": "SOFITEL BALI NUSA DUA BEACH RESORT",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 1367
        }, {
          "_id": "5ba920fc5a15581eccdd0c19",
          "id": 145,
          "name": "THE ANVAYA BEACH RESORT BALI",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 758
        }, {
          "_id": "5ba920fc5a15581eccdd0c1a",
          "id": 146,
          "name": "THE AYODYA PALACE",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 5
        }, {
          "_id": "5ba920fc5a15581eccdd0c1b",
          "id": 147,
          "name": "THE BANDHA HOTEL & SUITES",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 5
        }, {
          "_id": "5ba920fc5a15581eccdd0c1c",
          "id": 148,
          "name": "THE CHEDI CLUB TANAH GAJAH, UBUD",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 5
        }, {
          "_id": "5ba920fc5a15581eccdd0c1d",
          "id": 149,
          "name": "THE EDGE",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 141
        }, {
          "_id": "5ba920fc5a15581eccdd0c1e",
          "id": 150,
          "name": "THE LAGUNA, A LUXURY COLLECTION RESORT & SPA",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 5
        }, {
          "_id": "5ba920fc5a15581eccdd0c1f",
          "id": 151,
          "name": "THE LEGIAN BALI",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 6
        }, {
          "_id": "5ba920fc5a15581eccdd0c20",
          "id": 152,
          "name": "THE MULIA, MULIA RESORT & VILLAS - NUSA DUA, BALI",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 17
        }, {
          "_id": "5ba920fc5a15581eccdd0c21",
          "id": 153,
          "name": "THE ROYAL PITA MAHA RESORT & SPA",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 7
        }, {
          "_id": "5ba920fc5a15581eccdd0c22",
          "id": 154,
          "name": "THE SAMAYA SEMINYAK BALI",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 12
        }, {
          "_id": "5ba920fc5a15581eccdd0c23",
          "id": 155,
          "name": "THE SEMINYAK BEACH RESORT & SPA",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 7
        }, {
          "_id": "5ba920fc5a15581eccdd0c24",
          "id": 156,
          "name": "THE ST. REGIS BALI RESORT",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 13
        }, {
          "_id": "5ba920fc5a15581eccdd0c25",
          "id": 157,
          "name": "THE STONES HOTEL - LEGIAN, BALI - A MARRIOT AUTOGRAPH COLLECTION HOTEL",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 6
        }, {
          "_id": "5ba920fc5a15581eccdd0c26",
          "id": 158,
          "name": "THE UBUD VILLAGE RESORT & SPA",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 7
        }, {
          "_id": "5ba920fc5a15581eccdd0c27",
          "id": 159,
          "name": "THE WESTIN RESORT NUSA DUA, BALI",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 10
        }, {
          "_id": "5ba920fc5a15581eccdd0c28",
          "id": 160,
          "name": "W BALI - SEMINYAK",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 10
        }, {
          "_id": "5ba920fc5a15581eccdd0c29",
          "id": 161,
          "name": "WAPA DI UME RESORT & SPA",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 6
        }, {
          "_id": "5ba920fc5a15581eccdd0c2a",
          "id": 162,
          "name": "RAFFLES JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 185
        }, {
          "_id": "5ba920fc5a15581eccdd0c2b",
          "id": 163,
          "name": "FOUR SEASONS HOTEL JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 133
        }, {
          "_id": "5ba920fc5a15581eccdd0c2c",
          "id": 164,
          "name": "HOTEL MULIA SENAYAN",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 116
        }, {
          "_id": "5ba920fc5a15581eccdd0c2d",
          "id": 165,
          "name": "KERATON AT THE PLAZA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 208
        }, {
          "_id": "5ba920fc5a15581eccdd0c2e",
          "id": 166,
          "name": "FAIRMONT JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 107
        }, {
          "_id": "5ba920fc5a15581eccdd0c2f",
          "id": 167,
          "name": "THE RITZ-CARLTON JAKARTA, MEGA KUNINGAN",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 206
        }, {
          "_id": "5ba920fc5a15581eccdd0c30",
          "id": 168,
          "name": "SHANGRI-LA HOTEL, JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 139
        }, {
          "_id": "5ba920fc5a15581eccdd0c31",
          "id": 169,
          "name": "THE RITZ-CARLTON JAKARTA, PACIFIC PLACE",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 107
        }, {
          "_id": "5ba920fc5a15581eccdd0c32",
          "id": 170,
          "name": "HOTEL BOROBUDUR JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 118
        }, {
          "_id": "5ba920fc5a15581eccdd0c33",
          "id": 171,
          "name": "HOTEL INDONESIA KEMPINSKI JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 119
        }, {
          "_id": "5ba920fc5a15581eccdd0c34",
          "id": 172,
          "name": "GRAND HYATT JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 217
        }, {
          "_id": "5ba920fc5a15581eccdd0c35",
          "id": 173,
          "name": "GRAN MELIA JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 108
        }, {
          "_id": "5ba920fc5a15581eccdd0c36",
          "id": 174,
          "name": "THE WESTIN JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 289
        }, {
          "_id": "5ba920fc5a15581eccdd0c37",
          "id": 175,
          "name": "PULLMAN JAKARTA INDONESIA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 716
        }, {
          "_id": "5ba920fc5a15581eccdd0c38",
          "id": 176,
          "name": "AYANA MIDPLAZA, JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 189
        }, {
          "_id": "5ba920fc5a15581eccdd0c39",
          "id": 177,
          "name": "HOTEL DHARMAWANGSA JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 124
        }, {
          "_id": "5ba920fc5a15581eccdd0c3a",
          "id": 178,
          "name": "MANDARIN ORIENTAL, JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 122
        }, {
          "_id": "5ba920fc5a15581eccdd0c3b",
          "id": 179,
          "name": "HOTEL INTERCONTINENTAL JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 119
        }, {
          "_id": "5ba920fc5a15581eccdd0c3c",
          "id": 180,
          "name": "MERCURE JAKARTA PANTAI INDAH KAPUK",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 127
        }, {
          "_id": "5ba920fc5a15581eccdd0c3d",
          "id": 181,
          "name": "THE HERMITAGE, A TRIBUTE PORTFOLIO HOTEL, JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 101
        }, {
          "_id": "5ba920fc5a15581eccdd0c3e",
          "id": 182,
          "name": "AH YAT ABALONE SEAFOOD RESTAURANT",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 75
        }, {
          "_id": "5ba920fc5a15581eccdd0c3f",
          "id": 183,
          "name": "TABLE8 AT THE MULIA, MULIA RESORT & VILLAS - NUSA DUA BALI",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 30
        }, {
          "_id": "5ba920fc5a15581eccdd0c40",
          "id": 184,
          "name": "HAPPY CHAPPY",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 334
        }, {
          "_id": "5ba920fc5a15581eccdd0c41",
          "id": 185,
          "name": "SAKE NO HANA",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 16
        }, {
          "_id": "5ba920fc5a15581eccdd0c42",
          "id": 186,
          "name": "TENKAI AT PADMA RESORT LEGIAN",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 765
        }, {
          "_id": "5ba920fc5a15581eccdd0c43",
          "id": 187,
          "name": "NAMPU AT GRAND HYATT BALI",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 42
        }, {
          "_id": "5ba920fc5a15581eccdd0c44",
          "id": 188,
          "name": "MERAH PUTIH",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 26
        }, {
          "_id": "5ba920fc5a15581eccdd0c45",
          "id": 189,
          "name": "BLANCO PAR MANDIF",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 38
        }, {
          "_id": "5ba920fc5a15581eccdd0c46",
          "id": 190,
          "name": "KAUM AT POTATO HEAD BALI",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 35
        }, {
          "_id": "5ba920fc5a15581eccdd0c47",
          "id": 191,
          "name": "KAYUPUTI AT THE ST. REGIS BALI RESORT",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 34
        }, {
          "_id": "5ba920fc5a15581eccdd0c48",
          "id": 192,
          "name": "MOZAIC ",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 27
        }, {
          "_id": "5ba920fc5a15581eccdd0c49",
          "id": 193,
          "name": "KUBU AT MANDAPA, A RITZ-CARLTON RESERVE",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 46
        }, {
          "_id": "5ba920fc5a15581eccdd0c4a",
          "id": 194,
          "name": "SEASALT AT ALILA SEMINYAK",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 24
        }, {
          "_id": "5ba920fc5a15581eccdd0c4b",
          "id": 195,
          "name": "MAKASE AT HOTEL INDIGO BALI SEMINYAK BEACH",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 20
        }, {
          "_id": "5ba920fc5a15581eccdd0c4c",
          "id": 196,
          "name": "CUCA",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 25
        }, {
          "_id": "5ba920fc5a15581eccdd0c4d",
          "id": 197,
          "name": "CUCINA AT SOFITEL BALI NUSA DUA BEACH RESORT",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 876
        }, {
          "_id": "5ba920fc5a15581eccdd0c4e",
          "id": 198,
          "name": "SETTIMO CIELO",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 20
        }, {
          "_id": "5ba920fc5a15581eccdd0c4f",
          "id": 199,
          "name": "IL RISTORANTE - LUCA FANTIN AT BVLGARI RESORT BALI",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 42
        }, {
          "_id": "5ba920fc5a15581eccdd0c50",
          "id": 200,
          "name": "PLANTATION GRILL AT DOUBLE SIX LUXURY HOTEL",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 1561
        }, {
          "_id": "5ba920fc5a15581eccdd0c51",
          "id": 201,
          "name": "SALAZON",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 20
        }, {
          "_id": "5ba920fc5a15581eccdd0c52",
          "id": 202,
          "name": "POTATO HEAD BALI",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 28
        }, {
          "_id": "5ba920fc5a15581eccdd0c53",
          "id": 203,
          "name": "FIRE AT W BALI - SEMINYAK",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 37
        }, {
          "_id": "5ba920fc5a15581eccdd0c54",
          "id": 204,
          "name": "SOLEIL AT THE MULIA, MULIA RESORT & VILLAS - NUSA DUA BALI",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 31
        }, {
          "_id": "5ba920fc5a15581eccdd0c55",
          "id": 205,
          "name": "KUNYIT RESTAURANT",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 189
        }, {
          "_id": "5ba920fc5a15581eccdd0c57",
          "id": 207,
          "name": "40 THIEVES",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 46
        }, {
          "_id": "5ba920fc5a15581eccdd0c58",
          "id": 208,
          "name": "EN VIE LOUNGE",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 30
        }, {
          "_id": "5ba920fc5a15581eccdd0c59",
          "id": 209,
          "name": "WOOBAR  AT W BALI - SEMINYAK",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 31
        }, {
          "_id": "5ba920fc5a15581eccdd0c5a",
          "id": 210,
          "name": "FRESTRO & BAR",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 33
        }, {
          "_id": "5ba920fc5a15581eccdd0c5b",
          "id": 211,
          "name": "TREE BAR AT HOTEL INDIGO BALI SEMINYAK BEACH",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 30
        }, {
          "_id": "5ba920fc5a15581eccdd0c5c",
          "id": 212,
          "name": "SLING BAR AT DOUBLE SIX LUXURY HOTEL",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 78
        }, {
          "_id": "5ba920fc5a15581eccdd0c5d",
          "id": 213,
          "name": "OMNIA",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 29
        }, {
          "_id": "5ba920fc5a15581eccdd0c5e",
          "id": 214,
          "name": "EL KABRON",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 35
        }, {
          "_id": "5ba920fc5a15581eccdd0c5f",
          "id": 215,
          "name": "PEARL CHINESE RESTAURANT AT JW MARRIOTT HOTEL JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 25
        }, {
          "_id": "5ba920fc5a15581eccdd0c60",
          "id": 216,
          "name": "TIEN CHAO AT GRAN MELIA JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 29
        }, {
          "_id": "5ba920fc5a15581eccdd0c61",
          "id": 217,
          "name": "LI FENG  AT MANDARIN ORIENTAL, JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 27
        }, {
          "_id": "5ba920fc5a15581eccdd0c62",
          "id": 218,
          "name": "OKU AT HOTEL INDONESIA KEMPINSKI JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 32
        }, {
          "_id": "5ba920fc5a15581eccdd0c63",
          "id": 219,
          "name": "MOMOZEN",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 278
        }, {
          "_id": "5ba920fc5a15581eccdd0c64",
          "id": 220,
          "name": "ASUKA AT JW MARRIOTT HOTEL JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 80
        }, {
          "_id": "5ba920fc5a15581eccdd0c65",
          "id": 221,
          "name": "BOGOR CAFE AT HOTEL BOROBUDUR JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 71
        }, {
          "_id": "5ba920fc5a15581eccdd0c66",
          "id": 222,
          "name": "JAKARTA AT THE DHARMAWANGSA JAKARTA ",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 331
        }, {
          "_id": "5ba920fc5a15581eccdd0c67",
          "id": 223,
          "name": "PLATARAN MENTENG",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 27
        }, {
          "_id": "5ba920fc5a15581eccdd0c68",
          "id": 224,
          "name": "AMUZ",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 79
        }, {
          "_id": "5ba920fc5a15581eccdd0c69",
          "id": 225,
          "name": "AKIRA BACK",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 86
        }, {
          "_id": "5ba920fc5a15581eccdd0c6a",
          "id": 226,
          "name": "VONG KITCHEN",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 32
        }, {
          "_id": "5ba920fc5a15581eccdd0c6b",
          "id": 227,
          "name": "BAE BY SOCIEATY",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 78
        }, {
          "_id": "5ba920fc5a15581eccdd0c6c",
          "id": 228,
          "name": "COLLAGE ALL DAY DINING AT PULLMAN JAKARTA CENTRAL PARK ",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 52
        }, {
          "_id": "5ba920fc5a15581eccdd0c6d",
          "id": 229,
          "name": "UP IN SMOKE",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 29
        }, {
          "_id": "5ba920fc5a15581eccdd0c6e",
          "id": 230,
          "name": "GARCON",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 48
        }, {
          "_id": "5ba920fc5a15581eccdd0c6f",
          "id": 231,
          "name": "ROSSO AT SHANGRI-LA HOTEL, JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 43
        }, {
          "_id": "5ba920fc5a15581eccdd0c70",
          "id": 232,
          "name": "ALTO AT FOUR SEASONS HOTEL JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 118
        }, {
          "_id": "5ba920fc5a15581eccdd0c71",
          "id": 233,
          "name": "RUTH’S CHRIS STEAK HOUSE",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 131
        }, {
          "_id": "5ba920fc5a15581eccdd0c72",
          "id": 234,
          "name": "AB STEAK",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 122
        }, {
          "_id": "5ba920fc5a15581eccdd0c73",
          "id": 235,
          "name": "C’S STEAK AND SEAFOOD AT GRAND HYATT JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 52
        }, {
          "_id": "5ba920fc5a15581eccdd0c74",
          "id": 236,
          "name": "ASIA AT THE RITZ-CARLTON JAKARTA, MEGA KUNINGAN",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 106
        }, {
          "_id": "5ba920fc5a15581eccdd0c75",
          "id": 237,
          "name": "SEASONAL TASTES AT THE WESTIN JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 64
        }, {
          "_id": "5ba920fc5a15581eccdd0c76",
          "id": 238,
          "name": "BENGAWAN RESTAURANT AT KERATON AT THE PLAZA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 92
        }, {
          "_id": "5ba920fc5a15581eccdd0c77",
          "id": 239,
          "name": "DRAGONFLY",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 41
        }, {
          "_id": "5ba920fc5a15581eccdd0c78",
          "id": 240,
          "name": "K22 BAR",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 75
        }, {
          "_id": "5ba920fc5a15581eccdd0c79",
          "id": 241,
          "name": "IMMIGRANT",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 94
        }, {
          "_id": "5ba920fc5a15581eccdd0c7a",
          "id": 242,
          "name": "HENSHIN AT THE WESTIN JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 414
        }, {
          "_id": "5ba920fc5a15581eccdd0c7b",
          "id": 243,
          "name": "HAVANA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 75
        }, {
          "_id": "5ba920fc5a15581eccdd0c7c",
          "id": 244,
          "name": "WRITER’S BAR AT RAFFLES JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 42
        }, {
          "_id": "5ba920fc5a15581eccdd0c7d",
          "id": 245,
          "name": "OLIVIER",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 30
        }, {
          "_id": "5ba920fc5a15581eccdd0c7e",
          "id": 246,
          "name": "DE LUCA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 40
        }, {
          "_id": "5ba920fc5a15581eccdd0c7f",
          "id": 247,
          "name": "CAFE GRAN VIA AT GRAN MELIA JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 45
        }, {
          "_id": "5ba920fc5a15581eccdd0c80",
          "id": 248,
          "name": "ARTS CAFE AT RAFFLES JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 108
        }, {
          "_id": "5ba920fc5a15581eccdd0c81",
          "id": 249,
          "name": "THE JAPANESE AT SARI PACIFIC JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 31
        }, {
          "_id": "5ba920fc5a15581eccdd0c82",
          "id": 250,
          "name": "YOSHI IZAKAYA AT GRAN MELIA JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 256
        }, {
          "_id": "5ba920fc5a15581eccdd0c83",
          "id": 251,
          "name": "PASOLA AT THE RITZ-CARLTON JAKARTA, PACIFIC PLACE",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 23
        }, {
          "_id": "5ba920fc5a15581eccdd0c84",
          "id": 252,
          "name": "SIGNATURES RESTAURANT AT HOTEL INDONESIA KEMPINSKI JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 28
        }, {
          "_id": "5ba920fc5a15581eccdd0c85",
          "id": 253,
          "name": "SANA SINI RESTAURANT AT PULLMAN JAKARTA INDONESIA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 413
        }, {
          "_id": "5ba920fc5a15581eccdd0c86",
          "id": 254,
          "name": "ALTITUDE GRILL",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 93
        }, {
          "_id": "5ba920fc5a15581eccdd0c87",
          "id": 255,
          "name": "SHABU SHABU GEN",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 24
        }, {
          "_id": "5ba920fc5a15581eccdd0c88",
          "id": 256,
          "name": "RISTORANTE DA VALENTINO",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 23
        }, {
          "_id": "5ba920fc5a15581eccdd0c89",
          "id": 257,
          "name": "AL NAFOURA AT LE MERIDIEN JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 103
        }, {
          "_id": "5ba920fc5a15581eccdd0c8a",
          "id": 258,
          "name": "LA BRASSERIE AT LE MERIDIEN JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 35
        }, {
          "_id": "5ba920fc5a15581eccdd0c8b",
          "id": 259,
          "name": "L'AVENUE RESTAURANT AT THE HERMITAGE JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 36
        }, {
          "_id": "5ba920fc5a15581eccdd0c8c",
          "id": 260,
          "name": "PAULANER BRÄUHAUS AT HOTEL INDONESIA KEMPINSKI JAKARTA",
          "image": "",
          "location": "jakarta",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 27
        }, {
          "_id": "5ba9b9165a155825f05b5704",
          "id": 261,
          "name": "PADI FINE DINING",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 674
        }, {
          "_id": "5ba9bb425a155825f05b5710",
          "id": 262,
          "name": "SAMSARA UBUD",
          "image": "",
          "location": "bali",
          "category": "hotel",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 856
        },{
          "_id": "5ba9bb425a155825f05b5710",
          "id": 263,
          "name": "ABOVE ROOFTOP, LOUNGE & BAR",
          "image": "",
          "location": "bali",
          "category": "restaurant",
          "category_name": "",
          "code": "2018",
          "reader_choice": true,
          "status": false,
          "total_count": 534
        }
      ];
}
